import NetInfo, { NetInfoState } from '@react-native-community/netinfo'
import React, { createContext, useEffect, useState } from 'react'

interface INetworkContextData {
  isConnected: boolean
  handleReload: () => void
}

export const NetworkContext = createContext<INetworkContextData>(
  {} as INetworkContextData,
)

export const NetworkContextProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [isConnected, setIsConnected] = useState(true)

  const handleReload = () => {
    NetInfo.fetch().then((state) => {
      const connected = state.isConnected ?? false
      setIsConnected(connected)
    })
  }

  useEffect(() => {
    NetInfo.fetch().then((state: NetInfoState) => {
      const connected = state.isConnected ?? true
      setIsConnected(connected)
    })

    const unsubscribe = NetInfo.addEventListener((state: NetInfoState) => {
      const connected = state.isConnected ?? true
      setIsConnected(connected)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <NetworkContext.Provider value={{ isConnected, handleReload }}>
      {children}
    </NetworkContext.Provider>
  )
}
